import React from 'react';
import useUserRole, { ROLE_SUPERVISOR } from '../../hooks/useUserRole';
import ViewWeeklyRoutes from './ViewWeeklyRoutes';

// The page container is a class component and can't call hooks, so this thin
// wrapper resolves the LD role and passes the capability down as a prop.
export default function ViewWeeklyRoutesPage() {
  const { role } = useUserRole();
  return <ViewWeeklyRoutes canAssign={role === ROLE_SUPERVISOR} />;
}
